import React, { useState } from 'react';

const StudFinder = () => {
    const [scanning, setScanning] = useState(false);
    const [found, setFound] = useState(false);

    const playBeep = () => {
        const AudioContext = window.AudioContext || window['webkitAudioContext'];
        const audioCtx = new AudioContext();
        const now = audioCtx.currentTime;

        const oscillator = audioCtx.createOscillator();
        const gainNode = audioCtx.createGain();

        oscillator.connect(gainNode);
        gainNode.connect(audioCtx.destination);

        oscillator.type = 'square';
        oscillator.frequency.setValueAtTime(880, now);

        // Single long beep
        gainNode.gain.setValueAtTime(0.1, now);

        oscillator.start(now);
        oscillator.stop(now + 1.5); // Play for 1.5 seconds
    };

    const handleClick = () => {
        if (scanning) return;
        setScanning(true);
        setFound(false);

        setTimeout(() => {
            playBeep();
            setScanning(false);
            setFound(true);
            setTimeout(() => setFound(false), 2000);
        }, 2000);
    };

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: '#1a1a1a',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontFamily: 'Arial, sans-serif'
        }}>
            {/* Main Device Body */}
            <div style={{
                width: '280px',
                height: '450px',
                backgroundColor: '#fbc02d', // Safety Yellow
                borderRadius: '30px',
                boxShadow: '0 20px 50px rgba(0,0,0,0.8), inset 5px 5px 15px rgba(255,255,255,0.4), inset -5px -5px 15px rgba(0,0,0,0.2)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                position: 'relative',
                border: '4px solid #f57f17',
                transform: 'scale(1.5)'
            }}>
                {/* Sensor Head / Screen */}
                <div style={{
                    width: '100%',
                    height: '100px',
                    backgroundColor: '#222',
                    borderTopLeftRadius: '25px',
                    borderTopRightRadius: '25px',
                    borderBottom: '5px solid #111',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '0 20px',
                    boxSizing: 'border-box',
                    overflow: 'hidden'
                }}>
                    {found ? (
                        <div style={{
                            color: '#00ff00',
                            fontWeight: 'bold',
                            fontSize: '20px',
                            textAlign: 'center',
                            fontFamily: '"Courier New", Courier, monospace',
                            textShadow: '0 0 5px #00ff00',
                            animation: 'flash 0.5s infinite alternate'
                        }}>
                            HUGE STUD FOUND
                        </div>
                    ) : (
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-around',
                            width: '100%'
                        }}>
                            {/* Dummy LEDs */}
                            <div style={{ width: 15, height: 15, borderRadius: '50%', backgroundColor: scanning ? '#ffeb3b' : '#333', boxShadow: scanning ? '0 0 10px #ffeb3b' : 'inset 0 0 2px black', transition: '0.2s' }}></div>
                            <div style={{ width: 15, height: 15, borderRadius: '50%', backgroundColor: scanning ? '#ffeb3b' : '#333', boxShadow: scanning ? '0 0 10px #ffeb3b' : 'inset 0 0 2px black', transition: '0.2s', transitionDelay: '0.1s' }}></div>
                            <div style={{ width: 25, height: 25, borderRadius: '50%', backgroundColor: '#d32f2f', boxShadow: 'inset 0 0 5px rgba(0,0,0,0.5)' }}></div>
                            <div style={{ width: 15, height: 15, borderRadius: '50%', backgroundColor: scanning ? '#ffeb3b' : '#333', boxShadow: scanning ? '0 0 10px #ffeb3b' : 'inset 0 0 2px black', transition: '0.2s', transitionDelay: '0.2s' }}></div>
                            <div style={{ width: 15, height: 15, borderRadius: '50%', backgroundColor: scanning ? '#ffeb3b' : '#333', boxShadow: scanning ? '0 0 10px #ffeb3b' : 'inset 0 0 2px black', transition: '0.2s', transitionDelay: '0.3s' }}></div>
                        </div>
                    )}
                </div>

                {/* Grip / Handle Area */}
                <div style={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%'
                }}>
                    <div style={{
                        fontSize: '24px',
                        fontWeight: '900',
                        color: '#333',
                        marginBottom: '30px',
                        textShadow: '0 1px 0 rgba(255,255,255,0.4)',
                        letterSpacing: '1px'
                    }}>
                        STUD FINDER
                    </div>

                    {/* The Button */}
                    <button
                        onClick={handleClick}
                        style={{
                            width: '120px',
                            height: '120px',
                            borderRadius: '50%',
                            background: 'radial-gradient(circle at 30% 30%, #4a4a4a 0%, #2a2a2a 60%, #1a1a1a 100%)', // 3D ball look
                            border: '2px solid #111',
                            boxShadow: '0 10px 25px rgba(0,0,0,0.6), inset 0 2px 3px rgba(255,255,255,0.3), inset 0 -5px 10px rgba(0,0,0,0.5)', // Pop out
                            cursor: 'pointer',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            outline: 'none',
                            transform: scanning ? 'scale(0.95)' : 'scale(1)',
                            transition: 'all 0.1s ease',
                            position: 'relative'
                        }}
                    >
                        <div style={{
                            color: '#ccc',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            textTransform: 'uppercase'
                        }}>
                        </div>
                    </button>

                    <div style={{ marginTop: '40px', color: '#777', fontSize: '10px' }}>
                        MODEL: SF-3000
                    </div>
                </div>
            </div>

            <style>{`
                @keyframes flash {
                    from { opacity: 1; }
                    to { opacity: 0.2; }
                }
            `}</style>
        </div>
    );
};

export default StudFinder;
